import ContainerWithShadow from 'components/common/ContainerWithShadow';
// import CustomButton from 'components/common/customButton/customButton';
import Title from 'components/common/Title';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
// import plus from 'style/imgs/icons/plus.svg';
import {
  // createResources,
  // editResources,
  getResources,
  // deleteResources,
  testResource,
} from 'actions/signin-resources';
import _ from 'lodash';
import { ISigninResourcesState, ISigninResource } from 'types';
import { connect, useDispatch } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import buttons from 'style/buttons.module.scss';
// import _ from 'lodash';
import { formatLink } from 'utils/helpers/resourcesMap';
import { IRootState } from 'store';
import { useHistory } from 'react-router-dom';
import styles from './index.module.scss';
import SigninListItem from './signinListItem';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function createMock(itemId: number): ISigninResource {
  return {
    id: itemId,
    url: '',
    tested: false,
  };
}

const mapStateToProps = (state: IRootState) => ({
  resourcesState: state.signinResources,
  activeScholarId: state.users.userData?.activeScholarId,
});

interface IProps {
  resourcesState: ISigninResourcesState;
  activeScholarId: number | undefined;
}

const SigninWithCreds: React.FC<IProps> = ({
  activeScholarId,
  resourcesState,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { units } = resourcesState;

  // const [error, setError] = useState<string>('');
  const [alertOpen, changeAlertState] = useState<boolean>(false);
  const [resources, setResources] = useState<ISigninResource[]>(
    activeScholarId ? [createMock(0)] : []
  );

  useEffect(() => {
    if (activeScholarId) {
      dispatch(getResources(activeScholarId));
    }
  }, [dispatch, activeScholarId]);

  // const clearError = () => setError('');

  const savedResources = useMemo(
    () => (activeScholarId ? units[activeScholarId] : []),
    [activeScholarId, units]
  );

  useEffect(() => {
    if (activeScholarId && savedResources?.length > 0) {
      setResources(savedResources);
    }
  }, [resourcesState, activeScholarId, savedResources]);

  // const tryToSubmit = useCallback(
  //   (r: ISigninResource) => {
  //     if (!unitId || !r.url) {
  //       return;
  //     }

  //     const index = savedResources.findIndex((rs) => rs.id === r.id);
  //     const isCreation = index < 0;

  //     if (isCreation) {
  //       dispatch(
  //         createResources(r, +unitId, (err: string) => {
  //           setError(err);
  //         })
  //       );
  //     } else {
  //       const baseResource = savedResources[index];
  //       const isChanged = !_.isEqual(baseResource, r);

  //       if (isChanged) {
  //         dispatch(
  //           editResources(
  //             r,
  //             +unitId,
  //             (err: string) => {
  //               setError(err);
  //             },
  //             () => {
  //               changeAlertState(true);
  //             }
  //           )
  //         );
  //       }
  //     }
  //   },
  //   [unitId, savedResources, dispatch]
  // );

  // 16 June 2021
  // The ability to add/edit/delete links to signin with credetials removed
  // Now it's readonly list
  // const handleAdd = useCallback(() => {
  //   if (!unitId) {
  //     return;
  //   }

  //   const lastCreated = resources[resources.length - 1];

  //   if (!lastCreated) {
  //     setResources([createMock(0)]);
  //     return;
  //   }

  //   if (lastCreated.url?.length) {
  //     setResources((r) => {
  //       const newItem = [...r, createMock(lastCreated.id + 1)];
  //       return newItem;
  //     });
  //   }
  // }, [resources, unitId]);

  // const handleDelete = useCallback(
  //   (id: number) => {
  //     if (unitId) {
  //       const isNewItem = savedResources.findIndex((r) => r.id === id) === -1;

  //       if (isNewItem) {
  //         // delete it from component state
  //         setResources(resources.filter((r) => r.id !== id));
  //       } else {
  //         // delete it from DB
  //         dispatch(deleteResources(+unitId, id));
  //       }
  //     }

  //     setResources((prevState) => prevState.filter((r) => r.id !== id));
  //   },
  //   [dispatch, unitId, resources, savedResources]
  // );

  // const handleChange = useCallback(
  //   (id: number, url: string) => {
  //     setResources((prevState) => {
  //       clearError();

  //       const index = prevState.findIndex((r) => r.id === id);
  //       // eslint-disable-next-line no-bitwise
  //       if (~index) {
  //         const newResources = [...prevState];
  //         const updated = {
  //           ...prevState[index],
  //           url,
  //         };

  //         newResources.splice(index, 1, updated);
  //         tryToSubmit(updated);
  //         return newResources;
  //       }
  //       return prevState;
  //     });
  //   },
  //   [tryToSubmit]
  // );

  const onTested = useCallback(
    (res: ISigninResource) => {
      if (activeScholarId && res.url) {
        const url = formatLink(res.url);
        window.open(url, '_blank');
        dispatch(testResource(res, activeScholarId));
        setResources(savedResources);
      }
    },
    [activeScholarId, dispatch, savedResources]
  );

  const isButtonDisabled = () => {
    let result = true;
    if (
      _.every(resources, ['tested', true]) ||
      (resources.length === 1 && resources[0].url === '')
    ) {
      result = false;
    }
    return result;
  };

  const onClose = () => {
    changeAlertState(false);
  };

  const isSaved = (res: ISigninResource): boolean =>
    savedResources?.findIndex((r) => r.id === res.id) >= 0;

  return (
    <div className={styles.container}>
      <Snackbar open={alertOpen} autoHideDuration={3000} onClose={onClose}>
        <Alert onClose={onClose} severity="success">
          Done!
        </Alert>
      </Snackbar>
      <ContainerWithShadow
        className={`${styles.root} ${styles.heightContainer}`}
      >
        <Title className={styles.title}>Confirm Sign-in Credentials.</Title>
        <p className={styles.subTitle}>
          Test each link individually to ensure one-click access for your
          scholar. For smooth functioning, allow your browser to save the login
          credentials. Tested links will be moved to the bottom of the list
        </p>
        {/* <CustomButton
          color="mint"
          text="Add Resource"
          icon={plus}
          onClick={handleAdd}
        /> */}
        {/* TODO add sort */}
        <div className={styles.contentContainer}>
          {resources
            .sort((a) => (a.tested ? 1 : -1))
            .map((r, i) => (
              <SigninListItem
                key={r.id}
                index={i}
                resource={r}
                onDelete={() => undefined}
                onChange={() => undefined}
                onTested={onTested}
                saved={isSaved(r)}
              />
            ))}
        </div>
      </ContainerWithShadow>
      <div className={styles.buttons}>
        {/* {error && (
          <span className={`${styles.errorMsg} error-message`}>{error}</span>
        )} */}
        <button
          onClick={() => history.push('/onboarding/timetable/resources')}
          className={buttons.buttonOutline}
          type="button"
        >
          Back
        </button>
        <button
          type="submit"
          className={buttons.buttomPrimary}
          onClick={() => history.push('/сongratulations')}
          disabled={isButtonDisabled()}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(SigninWithCreds);
